import {useEffect} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";

import LoadingIndicator from "components/LoadingIndicator";

import {useGetAppointmentCampaigns} from "liberty-core/api/react-query/appointment";

import {useAuthenticatedUser} from "lib/auth";
import {redirectToParamsPage} from "lib/redirect";
import {useCurrentPharmacy} from "lib/useCurrentPharmacy";

import styles from "./RedirectPage.module.css";

export default function RedirectPage() {
  const [redirectParams] = useSearchParams();
  const [pharmacy] = useCurrentPharmacy();
  const [authenticatedUser, loadingUser] = useAuthenticatedUser();
  const navigate = useNavigate();
  const {data: apptCampaigns, isLoading: isLoadingApptCampaigns} =
    useGetAppointmentCampaigns(pharmacy?.id ?? 0, {enabled: !!pharmacy});

  useEffect(() => {
    const pageName = redirectParams.get("pageName")?.toUpperCase();
    if (
      !pageName ||
      (pageName !== "APPOINTMENTS" &&
        pageName !== "CHAT" &&
        pageName !== "INSURANCECARDS" &&
        pageName !== "MEDICATIONS" &&
        pageName !== "REGISTER" &&
        pageName !== "EXPRESSREGISTER" &&
        pageName !== "TAXREPORT" &&
        pageName !== "TRANSFERIN")
    ) {
      navigate("/");
    }
  }, [redirectParams, navigate]);

  useEffect(() => {
    const campaignId = redirectParams.get("campaignId");
    const optionId = redirectParams.get("optionId");
    const token = redirectParams.get("token");
    const pageName = redirectParams.get("pageName")?.toUpperCase();
    if (!loadingUser && !isLoadingApptCampaigns && pharmacy) {
      if (authenticatedUser) {
        redirectToParamsPage(
          navigate,
          redirectParams,
          authenticatedUser,
          apptCampaigns ?? [],
        );
      } else if (pageName === "APPOINTMENTS") {
        if (!campaignId && !optionId) {
          navigate(`/appointments?${redirectParams.toString()}`);
        } else {
          const apptCampaign = apptCampaigns?.find((c) => c.id === campaignId);
          if (apptCampaign) {
            if (optionId) {
              const hasValidOption = apptCampaign.appointmentOptions?.some(
                (option) => option.id === optionId,
              );
              if (hasValidOption) {
                navigate(
                  `/appointments/guest?campaignId=${campaignId}&optionId=${optionId}&pageName=APPOINTMENTS`,
                  {
                    state: {
                      apptCampaigns: [apptCampaign],
                    },
                  },
                );
              } else {
                navigate("/appointments", {
                  state: {invalidCampaignOrOptionIds: true},
                });
              }

              return;
            }
            navigate(
              `/appointments/guest?campaignId=${campaignId}&pageName=APPOINTMENTS`,
              {
                state: {
                  apptCampaigns: [apptCampaign],
                },
              },
            );
            return;
          }
          navigate("/appointments", {
            state: {invalidCampaignOrOptionIds: true},
          });
        }
      } else if (pageName === "REGISTER") {
        navigate(`/register`);
      } else if (pageName === "EXPRESSREGISTER") {
        if (!token) {
          navigate("/register");
        } else {
          navigate(`/express-register?token=${token}`);
        }
      } else {
        navigate(`/login?${redirectParams.toString()}`);
      }
    }
  }, [
    authenticatedUser,
    loadingUser,
    navigate,
    redirectParams,
    apptCampaigns,
    isLoadingApptCampaigns,
    pharmacy,
  ]);

  return (
    <div className={styles.container}>
      <LoadingIndicator />
    </div>
  );
}
